import * as React from 'react'
import { StackChildren, Text } from '@doordash/design-language'
import Button from '@doordash/component-button'
import {
  RiskActions,
  RiskContext,
  RiskWorkflows,
} from '@doordash/component-risk'
import { Mode, Channel } from './types'
import { ButtonGroup } from './styles'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { connect } from 'react-redux'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import t from './strings'

type ReduxProps = {
  trackWebviewMultiFactorAuth: (data: DA.WebviewMultiFactorAuth) => Promise<any>
}

type Props = {
  experiments?: any
  setMode: React.Dispatch<React.SetStateAction<Mode>>
  setChannel: React.Dispatch<React.SetStateAction<Channel>>
  setVerified: React.Dispatch<React.SetStateAction<boolean>>
}

export const VerifyPhoneNumber: React.FC<Props & ReduxProps> = ({
  experiments,
  setChannel,
  setMode,
  setVerified,
  trackWebviewMultiFactorAuth,
}) => {
  const { dispatch } = React.useContext(RiskContext)
  const os = detectWebviewOs()

  React.useEffect(() => {
    trackWebviewMultiFactorAuth({
      action: DA.EventActions.Rendered,
      name: DA.WebviewMultiFactorAuthNames.VerifyPhone,
    })
  }, [])

  const handleUpdatePhoneClicked = () => {
    trackWebviewMultiFactorAuth({
      action: DA.EventActions.Clicked,
      name: DA.WebviewMultiFactorAuthNames.UpdatePhone,
    })
    setMode(Mode.UpdatePhone)
  }

  const trigger2FAPhone = () => {
    trackWebviewMultiFactorAuth({
      action: DA.EventActions.Clicked,
      name: DA.WebviewMultiFactorAuthNames.VerifyPhone,
    })

    setChannel(Channel.Sms)

    dispatch({
      type: RiskActions.RegisterCallback,
      onClose: () => {
        trackWebviewMultiFactorAuth({
          action: DA.EventActions.Close,
          name: DA.WebviewMultiFactorAuthNames.VerifyPhone,
        })
      },
      onSuccess: () => {
        setVerified(true)

        trackWebviewMultiFactorAuth({
          action: DA.EventActions.Success,
          name: DA.WebviewMultiFactorAuthNames.VerifyPhone,
        })

        // if dasher is still onboarding, reload webview
        if (experiments.instant_dashing_v2 || experiments.dropshipping_status || experiments.bank_onboarding) {
          window.location.reload()
        } else {
          window.location.assign(
            os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
          )
        }
      },
    })

    dispatch({
      type: RiskActions.VerificationRequired,
      workflow: RiskWorkflows.DasherLogin,
    })
  }

  return (
    <StackChildren>
      <Text
        styles={Text.Styles.PageTitle}
        textAlign={Text.TextAlignments.Center}
      >
        {t.verifyPhone.title()}
      </Text>
      <Text
        styles={Text.Styles.PageSubtext}
        textAlign={Text.TextAlignments.Center}
      >
        {t.verifyPhone.subtitle()}
      </Text>
      <ButtonGroup>
        <Button onClick={trigger2FAPhone}>
          {t.verifyPhone.primaryAction()}
        </Button>
        <Button
          type={Button.Types.FlatPrimary}
          onClick={handleUpdatePhoneClicked}
        >
          {t.verifyPhone.secondaryAction()}
        </Button>
      </ButtonGroup>
    </StackChildren>
  )
}

const mapStateToProps = state => ({
  experiments: state.experiments,
})

const mapDispatchToProps = {
  trackWebviewMultiFactorAuth: events.trackWebviewMultiFactorAuth,
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyPhoneNumber)
